/* eslint-disable import/no-anonymous-default-export */
export default {
    uid: {
        url: "/mtd-api/assets-internal/getUid",
        method: "get"
    },
    sources: {
        url: "/mtd-api/assets-internal/sources",
        method: "get"
    },
    gallery: {
        search: "/mtd-api/assets-internal/image/search"
        // categories: (source) => `/px-api/images/categories/${source}`,
        // Img: (imageId, resourecId) => `/px-api/images/${imageId}/resource/${resourecId}/Img`,
    },
    image: {
        saveImage: {
            url: "/mtd-api/assets-internal/image/savePxImage",
            method: "post"
        },
        editImage: {
            url: "/mtd-api/assets-internal/image/editPxImage",
            method: "post"
        },
        getEditPxImage: {
            url: "/mtd-api/assets-internal/image/getEditPxImage",
            method: "get"
        },
        addImageToCleanDB: {
            // 以图搜图资源需要清理
            url: "/mtd-api/assets-internal/image/addImageToClean",
            method: "post"
        }
    },
    brandresources: {
        // 覆盖素材
        coverDirectoryUrl: {
            url: "/mtd-api/assets-internal/doc/coverDirectory",
            method: "post"
        },
        parentDirectoryList: {
            url: "/mtd-api/assets-internal/doc/getParentDirectoryList",
            method: "get"
        },
        directoryList: {
            url: "/mtd-api/assets-internal/doc/getDirectoryList",
            method: "get"
        },
        detail: {
            url: "/mtd-api/assets-internal/doc/getDocDetail",
            method: "get"
        },
        download: {
            url: "/mtd-api/assets-internal/doc/addDownload",
            method: "post"
        },
        getBgAndBrandPanelInfo: {
            url: "/mtd-api/assets-internal/doc/getBgAndBrandPanelInfo",
            method: "get"
        }
    },
    typeface: {
        list: {
            url: "/mtd-api/assets-internal/fonts",
            method: "get"
        },
        download: id => {
            return {
                url: `/mtd-api/assets-internal/fonts/${id}/download`,
                method: "get"
            };
        },
        downloadPackage: id => {
            return {
                url: `/mtd-api/assets-internal/fonts/sources/${id}/download`,
                method: "get"
            };
        }
    },
    my: {
        info: {
            url: "/mtd-api/assets-internal/org/mine",
            method: "get"
        },
        org: {
            url: "/mtd-api/assets-internal/search/org",
            method: "get"
        }
    },

    budgetManagemen: {
        costCenter: {
            url: "/mtd-api/assets-internal/budget/costCenter/list",
            method: "get"
        }, // 成本中心下拉选项接口
        overview: {
            url: "/px-api/v1/budget/manage/overview",
            method: "get"
        }, // 预算概况接口
        lineList: {
            url: "/px-api/v1/budget/manage/overview/lineList",
            method: "get"
        }, // 鼠标移至图商接口
        distribute: {
            url: "/px-api/v1/budget/manage/distribute/list",
            method: "get"
        }, // 预算分配列表接口
        user: {
            url: "/px-api/v1/budget/manage/user/list",
            method: "get"
        }, // 鼠标hover人数展示人接口
        add: {
            url: "/px-api/v1/budget/manage/distribute/add",
            method: "post"
        }, // 新增接口
        detail: {
            url: "/px-api/v1/budget/manage/distribute/user/detail",
            method: "get"
        }, // 编辑详情接口
        update: {
            url: "/px-api/v1/budget/manage/distribute/update",
            method: "put"
        }, // 编辑接口
        // freeze: {
        //   url: '/px-api/v1/budget/manage/distribute/freeze',
        //   method: 'put'
        // }, // 冻结接口
        // active: {
        //   url: '/px-api/v1/budget/manage/distribute/active',
        //   method: 'put'
        // }, // 激活接口
        transfer: {
            url: "/px-api/v1/budget/manage/distribute/transfer",
            method: "put"
        }, // 转移接口
        usedlist: {
            url: "/px-api/v1/budget/manage/used/list",
            method: "get"
        }, // 已使用明细接口
        all: {
            url: "/mtd-api/assets-internal/emp/search/all",
            method: "get"
        }, // 已使用明细接口

        downloadDemoImage: {
            url: "/mtd-api/assets-internal/download/demoImage",
            method: "post"
        }, // 图片小样图下载
        downloadImg: {
            url: "/mtd-api/assets-internal/download/image",
            method: "post"
        }, // 图片下载
        purchase: {
            url: "/mtd-api/assets-internal/image/purchase",
            method: "post"
        }, // 图片购买
        costCenters: {
            url: "/px-api/v1/image/purchase/costCenters",
            method: "get"
        }, // 购买时获取成本中心下拉列表接口
        detailImg: {
            url: "/mtd-api/assets-internal/image/detail",
            method: "get"
        }, // 图片详情接口
        operationList: {
            url: "/mtd-api/assets-internal/download/mydownload",
            method: "get"
        }, // 图片详情接口
        getCopyright: {
            url: "/mtd-api/assets-internal/image/getCopyright",
            method: "get"
        } // 授权文件
    },
    budgetManagementV2: {
        budgetlist: {
            url: "/mtd-api/assets-internal/capital/getBudgetlist",
            method: "get"
        },
        purchase: {
            url: "/mtd-api/assets-internal/image/purchase/v2",
            method: "post"
        },
        capitalUser: {
            url: "/mtd-api/assets-internal/capital/getCapitalUser",
            method: "get"
        },
        bill: {
            url: "/mtd-api/assets-internal/capital/bill",
            method: "post"
        },
        billAll: {
            url: "/mtd-api/assets-internal/capital/bill/all",
            method: "post"
        },
        budgetAdminList: {
            url: "/mtd-api/assets-internal/capital/budgetAdminList",
            method: "get"
        },
        applyApproval: {
            url: "/mtd-api/assets-internal/image/applyApproval",
            method: "get"
        }
    },
    marketMaterial: {
        // 查询目录
        directorylist: {
            url: "/mtd-api/assets-internal/market-material/getDirectoryList",
            method: "get"
        },
        // 改变文件目录
        changeMaterialDirectory: {
            url:
                "/mtd-api/assets-internal/market-material/changeMaterialDirectory",
            method: "post"
        },
        // 个人中心
        getMyMarketMaterialList: {
            url:
                "/mtd-api/assets-internal/market-material/getMyMarketMaterialList",
            method: "get"
        },
        // 获取根节点下所有的节点
        getFullDirectoryData: {
            url:
                "/mtd-api/assets-internal/market-material/getFullDirectoryData",
            method: "get"
        },
        // 文件夹是否可以删除
        directoryCanDelete: {
            url: "/mtd-api/assets-internal/market-material/directoryCanDelete",
            method: "get"
        },
        // 文件夹是否可以删除
        directoryCanDeleteV2: {
            url:
                "/mtd-api/assets-internal/market-material/directoryCanDeleteV2",
            method: "get"
        },
        // 返回用户组织目录下的0 1 2三级目录
        getInitOrgDirectoryList: {
            url:
                "/mtd-api/assets-internal/market-material/getInitOrgDirectoryList",
            method: "get"
        },
        // 更新文件夹名称
        updateDirectoryName: {
            url: "/mtd-api/assets-internal/market-material/updateDirectoryName",
            method: "post"
        },

        // 查询某个目录下的文件
        marketmateriallist: {
            url:
                "/mtd-api/assets-internal/market-material/getMarketMaterialList",
            method: "get"
        },
        // 查询当前用户相关组织的目录
        privilegeDirectoryList: {
            url:
                "/mtd-api/assets-internal/market-material/getPrivilegeDirectoryList",
            method: "get"
        },
        // 根节点目录
        orgDirectoryList: {
            url: "/mtd-api/assets-internal/market-material/getOrgDirectoryList",
            method: "get"
        },
        directoryAndProjectList: {
            url:
                "/mtd-api/assets-internal/market-material/getMarketDirectoryAndProjectList",
            method: "get"
        },
        // 前2级目录,包括根据点
        initDirectoreyList: {
            url:
                "/mtd-api/assets-internal/market-material/getInitDirectoryList",
            method: "get"
        },
        filetypelist: {
            url: "/mtd-api/assets-internal/market-material/getFileTypeList",
            method: "get"
        },

        marketDirectoryList: {
            url:
                "/mtd-api/assets-internal/market-material/getMarketDirectoryList",
            method: "get"
        },
        marketProjectList: {
            url:
                "/mtd-api/assets-internal/market-material/getMarketProjectList",
            method: "get"
        },
        getmarketmaterialdetail: {
            url:
                "/mtd-api/assets-internal/market-material/getMarketMaterialDetail",
            method: "get"
        },
        downloadmarketmaterial: {
            url:
                "/mtd-api/assets-internal/market-material/downloadMarketMaterial",
            method: "post"
        },
        removemkdir: {
            url: "/mtd-api/assets-internal/market-material/removeDirectory",
            method: "post"
        },
        deletemkdir: {
            url: "/mtd-api/assets-internal/market-material/deleteDirectory",
            method: "post"
        },
        deletemkdirV2: {
            url: "/mtd-api/assets-internal/market-material/deleteDirectoryV2",
            method: "post"
        },
        editmkdir: {
            url: "/mtd-api/assets-internal/market-material/editDirectory",
            method: "post"
        },
        editmkdirV2: {
            url: "/mtd-api/assets-internal/market-material/editDirectoryV2",
            method: "post"
        },
        deleteMaterialInfo: {
            url:
                "/mtd-api/assets-internal/market-material/deleteMaterialInfoBatch",
            method: "post"
        },
        getBrandManPermission: {
            url:
                "/mtd-api/assets-internal/market-material/getBrandManPermission",
            method: "get"
        }
    },
    marketGuideline: {
        // 查询目录
        directorylist: {
            url: "/mtd-api/assets-internal/market-guideline/getDirectoryList",
            method: "get"
        },
        // 目录排序
        directorySort: {
            url: "/mtd-api/assets-internal/market-guideline/sortDirectory",
            method: "post"
        },
        // 修改资源分类
        changeGuidelineDirectory: {
            url:
                "/mtd-api/assets-internal/market-guideline/changeGuidelineDirectory",
            method: "post"
        },
        // 获取营销规范列表
        marketGuidelinelist: {
            url:
                "/mtd-api/assets-internal/market-guideline/getmarketGuidelineList",
            method: "get"
        },
        // TODO 获取文件类型列表
        filetypelist: {
            url: "/mtd-api/assets-internal/market-guideline/getFileTypeList",
            method: "get"
        },
        // 获取营销规范
        getMarketGuidelineDetail: {
            url:
                "/mtd-api/assets-internal/market-guideline/getMarketGuidelineDetail",
            method: "get"
        },
        // 删除目录
        deletemkdir: {
            url: "/mtd-api/assets-internal/market-guideline/deleteDirectory",
            method: "post"
        },
        // 增加目录
        addmkdir: {
            url: "/mtd-api/assets-internal/market-guideline/addDirectory",
            method: "post"
        },
        // 编辑目录
        editmkdir: {
            url: "/mtd-api/assets-internal/market-guideline/editDirectory",
            method: "post"
        },
        // 上传和编辑、删除接口
        editmarketGuideline: {
            url:
                "/mtd-api/assets-internal/market-guideline/editMarketGuideline",
            method: "post"
        },
        // 删除营销规范素材
        deleteGuidelineInfoBatch: {
            url:
                "/mtd-api/assets-internal/market-guideline/deleteGuidelineInfoBatch",
            method: "post"
        }
    },
    teamRepository: {
        list: {
            url: "/mtd-api/assets-internal/gallery/list",
            method: "get"
        },
        update: {
            url: "/mtd-api/assets-internal/gallery/update",
            method: "post"
        },
        add: {
            url: "/mtd-api/assets-internal/gallery/add",
            method: "post"
        },
        delete: {
            url: "/mtd-api/assets-internal/gallery/delete",
            method: "post"
        },
        nameList: {
            url: "/mtd-api/assets-internal/gallery/nameList",
            method: "get"
        }
    },
    member: {
        resourcePermissionList: {
            url: "/mtd-api/assets-internal/member/getResourcePermissionList",
            method: "get"
        },
        insertSourcePermission: {
            url: "/mtd-api/assets-internal/member/insertSourcePermission",
            method: "post"
        },
        updatePermission: {
            url: "/mtd-api/assets-internal/member/updateSourcePermission",
            method: "post"
        },
        deletePermissionById: {
            url: "/mtd-api/assets-internal/member/deleteSourcePermissionById",
            method: "post"
        }
    },
    download: {
        // 下载小样
        downloaddemo: {
            url: "/mtd-api/assets-internal/download/downloadDemo",
            method: "post"
        }
    },
    audioAndVideo: {
        // 搜索video
        searchVideo: {
            url: "/mtd-api/assets-internal/audio-video/video/search",
            method: "get"
        },
        // video详情
        videodetail: {
            url: "/mtd-api/assets-internal/audio-video/video/detail",
            method: "get"
        },
        // video购买
        videopurchase: {
            url: "/mtd-api/assets-internal/audio-video/video/purchase",
            method: "post"
        },

        // 已购video的url
        videopurchaseurl: {
            url: "/mtd-api/assets-internal/audio-video/video/purchaseVideoUrl",
            method: "get"
        },

        // 已购video记录中心
        videopurchaserecords: {
            url:
                "/mtd-api/assets-internal/audio-video/video/getPurchaseRecords",
            method: "get"
        },

        // 搜索audio
        searchAudio: {
            url: "/mtd-api/assets-internal/audio-video/audio/search",
            method: "get"
        },
        // audio详情
        audiodetail: {
            url: "/mtd-api/assets-internal/audio-video/audio/detail",
            method: "get"
        },
        // audio购买
        audiopurchase: {
            url: "/mtd-api/assets-internal/audio-video/audio/purchase",
            method: "post"
        },

        // 已购记录中心
        audiopurchaserecords: {
            url:
                "/mtd-api/assets-internal/audio-video/audio/getPurchaseRecords",
            method: "get"
        },

        // 已购audio的url
        audiopurchaseurl: {
            url: "/mtd-api/assets-internal/audio-video/audio/purchaseAudioUrl",
            method: "get"
        }
    },
    // 团队管理
    teamManage: {
        // 是否是像素项目组成员
        hasDataDashboardAuth: {
            url: "/mtd-api/assets-internal/user/hasDataDashboardAuth",
            method: "get"
        },
        showTeamDataDashboard: {
            url: "/mtd-api/assets-internal/user/showTeamDataDashboard",
            method: "get"
        },
        //【指标口径】- 资产下载次数
        getResourcesDownloadCount: {
            url: "/mtd-api/assets-internal/dashboard/getResourcesDownloadCount",
            method: "get"
        },
        //【指标口径】- 资产数量统计
        getResourcesCount: {
            url: "/mtd-api/assets-internal/dashboard/getResourcesCount",
            method: "get"
        },
        //【指标口径】- 流量数据（P、UV）
        getPVAndUV: {
            url: "/mtd-api/assets-internal/dashboard/getPVAndUV",
            method: "get"
        },
        //【指标口径】- 团队使用平台数量
        getGroupsCount: {
            url: "/mtd-api/assets-internal/dashboard/getGroupsCount",
            method: "get"
        },
        //【指标口径】- 团队上传资产数量和排行
        getResourcesRank: {
            url: "/mtd-api/assets-internal/dashboard/getResourcesRank",
            method: "get"
        },
        //【指标口径】- 资产下载次数排行
        getResourcesDownloadRank: {
            url: "/mtd-api/assets-internal/dashboard/getResourcesDownloadRank",
            method: "get"
        },
        //【指标口径】- 被调用情况
        getResourcesUsed: {
            url: "/mtd-api/assets-internal/dashboard/getResourcesUsed",
            method: "get"
        },

        //【指标口径】- 花费金额
        getExpenseAmount: {
            url: "/mtd-api/assets-internal/dashboard/getExpenseAmount",
            method: "get"
        },
        //【指标口径】- 剩余预算
        getRemainingBudget: {
            url: "/mtd-api/assets-internal/dashboard/getRemainingBudget",
            method: "get"
        },
        //【指标口径】- 节省金额
        getSavedMoney: {
            url: "/mtd-api/assets-internal/dashboard/getSavedMoney",
            method: "get"
        },
        //【指标口径】- AIGC 节省时间
        getSavedTimeByAIGC: {
            url: "/mtd-api/assets-internal/dashboard/getSavedTimeByAIGC",
            method: "get"
        },
        //【团队指标口径】- 资产下载次数
        getTeamResourcesDownloadCount: {
            url:
                "/mtd-api/assets-internal/teamDashboard/getResourcesDownloadCount",
            method: "get"
        },
        //【团队指标口径】- 资产数量统计
        getTeamResourcesCount: {
            url: "/mtd-api/assets-internal/teamDashboard/getResourcesCount",
            method: "get"
        },
        //【团队指标口径】- 资产下载次数排行
        getTeamResourcesDownloadRank: {
            url:
                "/mtd-api/assets-internal/teamDashboard/getResourcesDownloadRank",
            method: "get"
        },
        //【团队指标口径】- 被调用情况
        getTeamResourcesUsed: {
            url: "/mtd-api/assets-internal/teamDashboard/getResourcesUsed",
            method: "get"
        },
        bussinesslist: {
            url: "/mtd-api/assets-internal/team-management/getTeamBgList",
            method: "get"
        },
        // 获取团队信息
        teamInfo: {
            url: "/mtd-api/assets-internal/team-management/getTeamInfo",
            method: "get"
        },
        teamList: {
            url: "/mtd-api/assets-internal/team-management/getTeamList",
            method: "get"
        },
        // 获取团队成员
        teamMembers: {
            url: "/mtd-api/assets-internal/team-management/getTeamMembers",
            method: "get"
        },
        // 新增团队成员
        addTeamMembers: {
            url: "/mtd-api/assets-internal/team-management/addTeamMembers",
            method: "post"
        },
        // 删除成员
        deleteTeamMember: {
            url: "/mtd-api/assets-internal/team-management/deleteTeamMember",
            method: "post"
        },
        // 获取营销的目录
        // getMaterialDirectory: {
        //   url: '/mtd-api/assets-internal/team-management/getMaterialDirectory',
        //   method: 'get'
        // },
        // 获取资源
        getResourceList: {
            url: "/mtd-api/assets-internal/team-management/getResourceList",
            method: "get"
        },
        // 获取资源总量
        getResourceListTotal: {
            url:
                "/mtd-api/assets-internal/team-management/getResourceListTotal",
            method: "get"
        },
        // 删除图片
        delectImages: {
            url: "/mtd-api/assets-internal/team-management/delectImages",
            method: "post"
        },
        // 删除品牌
        delectBrandDocs: {
            url: "/mtd-api/assets-internal/team-management/delectBrandDocs",
            method: "post"
        },
        // 批量更新图片某个属性
        updateImagesBatch: {
            url: "/mtd-api/assets-internal/team-management/updateImagesBatch",
            method: "post"
        },
        updateTeamAvatar: {
            url: "/mtd-api/assets-internal/team-management/updateTeamAvatar",
            method: "post"
        },
        // 搜索组织架构或者mis号
        searchOrgOrMis: {
            url: "/mtd-api/assets-internal/team-management/searchOrgOrMis",
            method: "get"
        },
        // 获取所有分类菜单权限
        getPixelManPermission: {
            url:
                "/mtd-api/assets-internal/team-management/getPixelManPermission",
            method: "get"
        }
    },
    downloadManage: {
        downloadTotal: {
            url: "/mtd-api/assets-internal/download/myDownloadTotal",
            method: "get"
        },
        myImageDownload: {
            url: "/mtd-api/assets-internal/download/myImageDownload",
            method: "get"
        },
        myBrandDownload: {
            url: "/mtd-api/assets-internal/download/myBrandDownload",
            method: "get"
        }
    },
    human: {
        editprops: {
            url:
                "/mtd-api/assets-internal/corporate-culture-material/editprops",
            method: "post"
        },
        list: {
            url: "/mtd-api/assets-internal/corporate-culture-material/search",
            method: "get"
        },
        saveppt: {
            url:
                "/mtd-api/assets-internal/corporate-culture-material/editMaterial",
            method: "post"
        },
        detail: {
            url: "/mtd-api/assets-internal/corporate-culture-material/detail",
            method: "get"
        }
    },
    humanDesign: {
        createDirectory: {
            url: "/mtd-api/assets-internal/human-design/createDirectory",
            method: "post"
        },
        getDirecoryList: {
            url: "/mtd-api/assets-internal/human-design/getDirecoryList",
            method: "get"
        },
        createMaterial: {
            url: "/mtd-api/assets-internal/human-design/createMaterial",
            method: "post"
        },
        editMaterial: {
            url: "/mtd-api/assets-internal/human-design/editMaterial",
            method: "post"
        },
        getMaterialList: {
            url: "/mtd-api/assets-internal/human-design/getMaterialList",
            method: "get"
        }
    },
    // 设计指南
    designGuide: {
        createMaterial: {
            url: "/mtd-api/assets-internal/design-guide/createMaterial",
            method: "post"
        },
        editMaterial: {
            url: "/mtd-api/assets-internal/design-guide/editMaterial",
            method: "post"
        },
        getMaterialList: {
            url: "/mtd-api/assets-internal/design-guide/getMaterialList",
            method: "get"
        }
    },
    home: {
        getFestivel: {
            url: "/mtd-api/assets-internal/getFestivalByLion",
            method: "get"
        },
        getHolidayInfo: {
            url: "/mtd-api/assets-internal/getHolidayInfo",
            method: "get"
        }
    },
    search: {
        globalSearch: {
            url: "/mtd-api/assets-internal/globalSearch",
            method: "get"
        },
        globalSearchV2: {
            url: "/mtd-api/assets-internal/globalSearchV2",
            method: "get"
        },
        insertSearchRecord: {
            url: "/mtd-api/assets-internal/insertSearchRecord",
            method: "post"
        },
        getSearchRecord: {
            url: "/mtd-api/assets-internal/getSearchRecord",
            method: "get"
        },
        getHotSearchRecord: {
            url: "/mtd-api/assets-internal/hotSearchRecord",
            method: "get"
        },
        deleteSearchRecord: {
            url: "/mtd-api/assets-internal/deleteSearchRecord",
            method: "post"
        },
        getSuggest: {
            url: "/mtd-api/assets-internal/search/suggest",
            method: "get"
        }
    },
    product: {
        editprops: {
            url: "/mtd-api/assets-internal/productmaterial/product/editprops",
            method: "post"
        },
        productrelated: {
            url:
                "/mtd-api/assets-internal/productmaterial/product/list/related",
            method: "get"
        },
        productdetailbatch: {
            url: "/mtd-api/assets-internal/productmaterial/product/detailbatch",
            method: "get"
        },
        productdetail: {
            url: "/mtd-api/assets-internal/productmaterial/product/detail",
            method: "get"
        },
        officialdetail: {
            url: "/mtd-api/assets-internal/productmaterial/design/detail",
            method: "get"
        },
        materialcreate: {
            // TODO AIGC支持
            url: "/mtd-api/assets-internal/productmaterial/product/create",
            method: "post"
        },
        officialcreate: {
            url: "/mtd-api/assets-internal/productmaterial/design/create",
            method: "post"
        },
        productlist: {
            url: "/mtd-api/assets-internal/productmaterial/product/list",
            method: "get"
        },
        officiallist: {
            url: "/mtd-api/assets-internal/productmaterial/design/list",
            method: "get"
        },
        directorylist: {
            url: "/mtd-api/assets-internal/productmaterial/directory/list",
            method: "get"
        }
    },
    temp: {
        picSearch: {
            url: "/mtd-api/assets-internal/team-management/temp/searchPic",
            method: "get"
        },
        addPic: {
            url: "/mtd-api/assets-internal/team-management/temp/addPic",
            method: "post"
        },
        deletePic: {
            url: "/mtd-api/assets-internal/team-management/temp/deletePic",
            method: "post"
        }
    },
    // 素材相关操作
    materialoperaion: {
        url: "/mtd-api/assets-internal/log/add",
        method: "post"
    },
    materialoperationinfo: {
        url: "/mtd-api/assets-internal/materialoperationinfo",
        method: "post"
    },
    aigc: {
        list: {
            url: "/mtd-api/assets-internal/aigc/list",
            method: "get"
        },
        detail: {
            url: "/mtd-api/assets-internal/aigc/detail",
            method: "get"
        }
    },
    authorizedSubject: {
        list: {
            url: "/mtd-api/assets-internal/authorized-subject/list",
            method: "get"
        }
    },
    materialAuth: {
        getMaterialsAuth: {
            url: "/mtd-api/assets-internal/materialAuth/getMaterialsAuth",
            method: "get"
        },
    },
    authCode: {
        getAuthCodesList: {
            url: "/mtd-api/assets-internal/authCode/getAuthCodesList",
            method: "get"
        },
        unbindUser: {
            url: "/mtd-api/assets-internal/authCode/unbindUser",
            method: "get"
        },
        updateAuthCode: {
            url: "/mtd-api/assets-internal/authCode/updateAuthCode",
            method: "post"
        },
        activeAuthCode: {
            url: "/mtd-api/assets-internal/authCode/activeAuthCode",
            method: "get"
        },
        getNewAuthCode: {
            url: "/mtd-api/assets-internal/authCode/getNewAuthCode",
            method: "get"
        }
    },
    myFavorite: {
        getFavoriteList: {
            url: "/mtd-api/assets-internal/favorite/getFavoriteList",
            method: "get"
        },
        delFavorite: {
            url: "/mtd-api/assets-internal/favorite/delFavorite",
            method: "post"
        },
        addFavorite: {
            url: "/mtd-api/assets-internal/favorite/addFavorite",
            method: "post"
        },
        getFavoriteTotal: {
            url: "/mtd-api/assets-internal/favorite/getFavoriteTotal",
            method: "get"
        }
    },
    iconfont: {
        repository: {
            directorylist: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getDirectoryList",
                method: "get"
            },
            addmkdir: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/addDirectory",
                method: "post"
            },
            deletemkdir: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/deleteDirectory",
                method: "post"
            },
            editmkdir: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/editDirectory",
                method: "post"
            },
            repoList: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getRepoList",
                method: "get"
            },
            detail: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getRepoOrProjectDetail",
                method: "get"
            },
            editRepo: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/editRepo",
                method: "post"
            },
            deleteRepo: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/deleteRepo",
                method: "post"
            },
            getRepoUrl: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getRepoUrl",
                method: "get"
            },
            getFixedUrlInfo: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getFixUrlInfo",
                method: "get"
            },
            pubFixedUrl: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/publishFixUrl",
                method: "post"
            },
            copyRepo: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/copyRepo",
                method: "post"
            },
            getRepoVersionList: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getRepoVersionList",
                method: "get"
            },
            getCompareRepoVersion: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getCompareRepoVersion",
                method: "get"
            },
            getLogs: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getRepoOperationLog",
                method: "get"
            },
            generateNewVersion: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/generateRepoVersion",
                method: "post"
            },
            downloadProject: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/downloadZip",
                method: "get"
            },
            getRepoBriefDetail: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/getRepoBriefDetail",
                method: "get"
            },
            reactionRepo: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/reactionRepo",
                method: "post"
            },
            addIconsToProject: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/repository/addIconsToProject",
                method: "post"
            }
        },
        icon: {
            iconList: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/getIconList",
                method: "get"
            },
            uploadIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/batchUploadIcon",
                method: "postFileWithEncode"
            },
            getUploadedIconList: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/getUploadedIconList",
                method: "get"
            },
            batchSubmitIconList: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/batchCommitIcon",
                method: "post"
            },
            getIconDetail: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/getIconDetail",
                method: "get"
            },
            downloadIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/downloadIcon",
                method: "get"
            },
            transferPath: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/transferPath",
                method: "post"
            },
            editIcon: {
                url: "/mtd-api/assets-internal/iconfont/resource/icon/editIcon",
                method: "post"
            },
            deleteIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/removeIcon",
                method: "post"
            },
            deactivateIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/deactivateIcon",
                method: "post"
            },
            checkIconUsed: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/checkIconUsed",
                method: "get"
            },
            activateIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/activateIcon",
                method: "post"
            },
            batchDownloadIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/batchDownloadIcon",
                method: "get"
            },
            deleteAllUnAssignedIcon: {
                url:
                    "/mtd-api/assets-internal/iconfont/resource/icon/removeUnassignedIconBatch",
                method: "post"
            }
        }
    },
    // 品牌规范管理
    brandAggregation: {
        // 合集
        collection: {
            // 搜索合集
            searchCollectionData: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/search",
                method: "get"
            },
            // 获取合集详情
            getCollectionDetail: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/detail",
                method: "get"
            },
            // 获取合集列表
            getCollectionList: {
                url: "/mtd-api/assets-internal/brand-guideline/collection/list",
                method: "get"
            },
            // 创建合集
            createCollection: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/create",
                method: "post"
            },
            // 关联规范资产到合集
            relateCollection: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/relate",
                method: "post"
            },
            // 取消关联规范资产
            unrRelateCollection: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/unrelate",
                method: "post"
            },
            // 更新合集
            updateCollection: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/update",
                method: "post"
            },
            // 删除合集
            deleteCollection: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/collection/delete",
                method: "post"
            }
        },
        // 品牌规范详情
        assets: {
            // 创建品牌规范
            createAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-guideline/info/create",
                method: "post"
            },
            // 获取品牌规范列表
            getAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-guideline/info/search",
                method: "get"
            },
            // 更新品牌规范
            updateAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-guideline/info/update",
                method: "post"
            },
            // 删除品牌规范
            deleteAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-guideline/info/delete",
                method: "post"
            },
            // 查询个人品牌规范下载记录列表
            myBrandDownload: {
                url: "/mtd-api/assets-internal/download/myBrandDownload",
                method: "get"
            },
            // 获取品牌规范详情
            detailAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-guideline/info/detail",
                method: "get"
            }
        },
        // 目录
        catalogue: {
            // 排序
            sortCatalogue: {
                url: "/mtd-api/assets-internal/brand-guideline/directory/sort",
                method: "post"
            },
            // 获取目录列表
            getCatalogue: {
                url: "/mtd-api/assets-internal/brand-guideline/directory/list",
                method: "get"
            },
            // 添加目录列表
            addCatalogue: {
                url: "/mtd-api/assets-internal/brand-guideline/directory/add",
                method: "post"
            },
            // 更新目录列表
            apdateCatalogue: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/directory/update",
                method: "post"
            },
            // 删除目录列表
            deleteCatalogue: {
                url:
                    "/mtd-api/assets-internal/brand-guideline/directory/delete",
                method: "post"
            }
        },
        // 新增下载记录
        addDownloadRecord: {
            url: "/mtd-api/assets-internal/download/addDownloadRecord",
            method: "post"
        },
        // 查询下载记录
        myDownloadTotal: {
            url: "/mtd-api/assets-internal/download/myDownloadTotal",
            method: "get"
        },
        // 是否拥有上传权限
        checkUploadPermission: {
            url: "/mtd-api/assets-internal/checkUploadPermission",
            method: "get"
        },
        catalogueOuter: {
            // 获取目录列表
            getCatalogue: {
                url:
                    "/mtd-api/assets-internal/outer/brand-guideline/directory/list",
                method: "get"
            }
        },
        collectionOuter: {
            // 搜索合集
            searchCollectionData: {
                url:
                    "/mtd-api/assets-internal/outer/brand-guideline/collection/search",
                method: "get"
            },
            // 获取合集详情
            getCollectionDetail: {
                url:
                    "/mtd-api/assets-internal/outer/brand-guideline/collection/detail",
                method: "get"
            },
            // 获取合集列表
            getCollectionList: {
                url:
                    "/mtd-api/assets-internal/outer/brand-guideline/collection/list",
                method: "get"
            }
        },
        assetsOuter: {
            // 获取品牌规范列表
            getAssetsDetail: {
                url:
                    "/mtd-api/assets-internal/outer/brand-guideline/info/search",
                method: "get"
            },
            // 获取品牌规范详情
            detailAssetsDetail: {
                url:
                    "/mtd-api/assets-internal/outer/brand-guideline/info/detail",
                method: "get"
            }
        },
        addDownloadRecordOuter: {
            url: "/mtd-api/assets-internal/outer/download/addDownloadRecord",
            method: "post"
        }
    },
    searchOuter: {
        globalSearchV2: {
            url: "/mtd-api/assets-internal/outer/global/globalSearch",
            method: "get"
        }
    },
    materialoperaionOuter: {
        url: "/mtd-api/assets-internal/outer/global/logAdd",
        method: "post"
    },
    // 品牌市场素材
    brandDesign: {
        // 目录
        catalogue: {
            // 排序
            sortCatalogue: {
                url: "/mtd-api/assets-internal/brand-market/directory/sort",
                method: "post"
            },
            // 获取目录列表
            getCatalogue: {
                url: "/mtd-api/assets-internal/brand-market/directory/list",
                method: "get"
            },
            // 添加目录列表
            addCatalogue: {
                url: "/mtd-api/assets-internal/brand-market/directory/add",
                method: "post"
            },
            // 更新目录列表
            apdateCatalogue: {
                url: "/mtd-api/assets-internal/brand-market/directory/update",
                method: "post"
            },
            // 删除目录列表
            deleteCatalogue: {
                url: "/mtd-api/assets-internal/brand-market/directory/delete",
                method: "post"
            }
        },
        // 品牌市场详情
        assets: {
            // 创建品牌市场
            createAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-market/info/create",
                method: "post"
            },
            // 获取品牌市场列表
            getAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-market/info/search",
                method: "get"
            },
            // 更新品牌市场
            updateAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-market/info/update",
                method: "post"
            },
            // 删除品牌市场
            deleteAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-market/info/delete",
                method: "post"
            },
            // 获取品牌市场详情
            detailAssetsDetail: {
                url: "/mtd-api/assets-internal/brand-market/info/detail",
                method: "get"
            },
            // 查询个人品牌规范下载记录列表
            myMaterialDownload: {
                url: "/mtd-api/assets-internal/download/myMaterialDownload",
                method: "get"
            }
        }
    },
    // 营销规范
    InAppSpecs: {
        // 目录
        catalogue: {
            // 获取目录列表
            getCatalogue: {
                url:
                    "/mtd-api/assets-internal/market-guideline/getDirectoryList",
                method: "get"
            },
            // 添加目录列表
            addCatalogue: {
                url: "/mtd-api/assets-internal/market-guideline/addDirectory",
                method: "post"
            },
            // 更新目录列表
            apdateCatalogue: {
                url: "/mtd-api/assets-internal/market-guideline/editDirectory",
                method: "post"
            },
            // 删除目录列表
            deleteCatalogue: {
                url:
                    "/mtd-api/assets-internal/market-guideline/deleteDirectory",
                method: "post"
            }
        },
        // 营销规范详情
        assets: {
            // 创建营销规范
            createAssetsDetail: {
                url: "/mtd-api/assets-internal/market-guideline/create",
                method: "post"
            },
            // 获取营销规范列表
            getAssetsDetail: {
                url: "/mtd-api/assets-internal/market-guideline/search",
                method: "get"
            },
            // 更新营销规范
            updateAssetsDetail: {
                url: "/mtd-api/assets-internal/market-guideline/update",
                method: "post"
            },
            // 删除营销规范
            deleteAssetsDetail: {
                url: "/mtd-api/assets-internal/market-guideline/delete",
                method: "post"
            },
            // 获取营销规范详情
            detailAssetsDetail: {
                url: "/mtd-api/assets-internal/market-guideline/detail",
                method: "get"
            }
        }
    },
    upload: {
        autoTag: {
            url: "/mtd-api/assets-internal/upload/autoTag",
            method: "get"
        }
    },
    // 新增的权限。TODO后续的为 materialAuth的 key 是否考虑删除
    materialAuths: {
        // 添加权限/删除权限 
        batchUpdateMaterialsAuth: {
            url: "/mtd-api/assets-internal/materialAuth/batchUpdateMaterialsAuth",
            method: "post"
        },
        //获取默认权限列表
        getMaterialsDefaultAuth: {
            url: "/mtd-api/assets-internal/materialAuth/getMaterialsDefaultAuth",
            method: "get"
        },
        //获取权限列表
        getMaterialAuthList: {
            url: "/mtd-api/assets-internal/materialAuth/getMaterialsAuth",
            method: "get"
        },
        //搜索mis列表
        searchOrgOrMis: {
            url: "/mtd-api/assets-internal/team-management/searchOrgOrMis",
            method: "get"
        },
        // 申请权限
        applyAuth: {
            url: "/mtd-api/assets-internal/materialAuth/applyAuth",
            method: "post"
        }
    }
    
};
